const locales ={
    ACCOUNT: 'Account',
    ACCOUNT_DONT_HAVE_SPE: 'Given account doesn\'t have spe module',
    ACCOUNT_FILLING: 'Account filling',
    ACCOUNT_NOT_FOUND: 'Account not found',
    ACCOUNTS: 'Accounts',
    ACCOUNTS_MANAGER: 'Accounts Manager',
    ACTION_TYPE: 'Action type',
    ACTIONS: 'Actions',
    ACTIVITY: 'Activity',
    ADD_ACCOUNT: 'Create account',
    ADD_CATALOG: 'Add a catalog',
    ADD_EMAIL: 'Add an email',
    ADD_NEW_URL_INPUT: 'Add a new URL',
    ADD_PERFORMANCE: 'Add a performance',
    ADD_PROXY: 'Add a proxy',
    ADD_SITE: 'Create a site',
    ADD_SITES_TO_SCRAP: 'Add sites to scrap',
    ADD_SLIDER_CONFIG_FOR: 'Add a slider config for {siteName}',
    ADD_SPE_CONFIG_FOR: 'Add a SPE config for {siteName}',
    ADD_USER: 'Create a user',
    ADVANCED_PARAMETERS: 'Advanced parameters',
    ADVANCED_PARAMETERS_SUBTITLE: 'This window enables you to modify the delay before the script execution (site speed ↘ wait ↗), and to add a proxy, which will be used with all the filled URLs.',
    ALPHABETICAL_ORDER: 'Alphabetical order',
    ALTERNATIVE_URL: 'Alternative url',
    ANALYZE: 'Analyze',
    AND: 'and',
    ANTI_ALPHABETICAL_ORDER: 'Anti-alphabetical order',
    ANTI_CHRONOLOGICAL_ORDER: 'Anti-chonological order',
    ARTICLE_ATTRIBUTE: 'Article attribute',
    ARTICLE_MATCH_RULE: 'Article in input with at least one match in base',
    ASCENDING_ORDER: 'Ascending order',
    ASIN: 'ASIN',
    ATTRIBUTE: 'Attribute',
    ATTRIBUTE_OPTIONAL: 'Attribute optional',
    ATTRIBUTE_REQUIRED: 'Required attribute',
    BACK: 'Back',
    BAD_PROXY: 'Mauvais proxy',
    BOT_VERSION: 'Bot version',
    BRAND: 'Brand',
    CANCEL: 'Cancel',
    CATALOG: 'Catalog',
    CATALOG_ADD_SUBTITLE: 'This window enables you to add a catalog, by informing his name, his update delay, and his activity.',
    CATALOG_DELETE_SUBTITLE: 'This window enables to to delete a catalog.',
    CATALOG_INFORMATION_SUBTITLE: 'Here are informations about the last {catalogName} update :',
    CATALOG_MINIMUM_DELAY: 'Le délai minimum est de 1 semaine',
    CATALOG_NAME: 'Catalog Name',
    CATALOG_PARAM_SUBTITLE: 'This window enables you to modify a catalog name, the delay between updates, and its activity.\n',
    CATALOG_SCRIPT_NAME: 'Nom du script catalogue',
    CATALOG_UPDATE: 'CatalogUpdater',
    CATALOG_UPDATE_ACTIVATED: 'Automatic update activated',
    CATALOG_UPDATE_DISABLED: 'Automatic update disabled',
    CATALOGS: 'Catalogs',
    CATEGORY: 'Category',
    CATEGORY_ID: 'Category',
    CATEGORY_NAME: 'Category',
    CHANGE_PASSWORD: 'Change password',
    CHANGE_PASSWORD_DISCLAIMER: 'Are you sure to change your password ?',
    CHANGE_USERNAME: 'Change username',
    CHANGE_USERNAME_DISCLAIMER: 'Are you sure to change your username ?',
    CHECK_ALL: 'Check all',
    CHOOSE_A_DELAY: 'Choose a delay',
    CHOOSE_COUNTRY: 'Choose a country',
    CHRONOLOGICAL_ORDER: 'Chronological order',
    CLOSE: 'Close',
    CMS_LAST_KNOWN_STOCK: 'CMS STOCK',
    CMS_PRODUCT_ID: 'CMS ID',
    COLOR: 'Color',
    COMMENT: 'Comment',
    CONFIGURATION_SLIDER: 'Configuration Slider',
    CONFIGURATION_SPE: 'Configuration SPE',
    CONFIGURED_SITES: 'Configured sites',
    CONFIRM: 'Confirm',
    CONFIRM_PASSWORD: 'Confirm password',
    CONFIRM_SITE_ADBOX_CONFIG: 'Caution, you have text that is not added to the email list. Do you want to add it?',
    CONFIRMATION_CATALOG_DELETE_DISCLAIMER: 'Are you sure about deleting {catalogName} ? This action is irreversible :',
    CONFIRMATION_DELETE_SITE_FROM_ACCOUNT: 'Do you really want to delete the site {siteToDelete} from the account {accountName} ?',
    CONFIRMATION_UPDATE_ACCOUNT: 'Are you sure about updating {accountName} ? This action is irreversible and every scraped data of updated site will be deleted',
    CONTROL_TOWER: 'Control tower',
    COPY_TO_CLIPBOARD: 'Copy to clipboard',
    COUNTRY: 'Country',
    CURRENCY: 'Currency',
    CURRENT_PASSWORD: 'Current password',
    DAILY_RECAP: 'DailyRecap',
    DASHBOARD: 'Dashboard',
    DATA_SAMPLE: 'Data sample',
    DATE: 'Date',
    DAY: 'Days',
    DAYS: 'Days',
    DEFAULT_FILTERS: 'Reset filters',
    DEFAULT_SETTINGS: 'Default settings',
    DELAY: 'Delay',
    DELETE: 'Delete',
    DELETE_CATALOG: 'Delete a catalog',
    DELETE_PROXY: 'Delete a proxy',
    DESCENDING_ORDER: 'Descending order',
    DISABLE_AUTOMATIC_CATALOG_UPDATE: 'Disable the automatic update for this catalog',
    DISCONNECTED: 'You have been disconnected',
    DISPLAY_DONE_ROW: 'Display row already done',
    DISPLAY_PENDING_ONLY: 'Display only PENDING',
    DOWNLOAD: 'Download',
    DOWNLOAD_DIALOG_DEFINITION: 'To download this script, enter a file name and click on the download button.',
    DROP_HERE: 'Drop here',
    DUPLICATE: 'Duplicate',
    DUPLICATE_ACCOUNT: 'Duplicate the account {name}',
    EAN: 'EAN',
    EDIT_ACCOUNT: 'Edit an account',
    EDIT_PRICE: 'Edit price',
    EDIT_PROXY: 'Edit a proxy',
    EDIT_SITE: 'Edit a site',
    EDIT_URL: 'Edit url',
    EDIT_USER: 'Edit a user',
    EMAIL: 'Email',
    EMPTY: 'Empty',
    ENABLE_AUTOMATIC_CATALOG_UPDATE: 'Enable the automatic update for this catalog',
    ENTER_YOUR_CURRENT_PASSWORD: 'Enter your current password',
    ENTER_YOUR_NEW_PASSWORD: 'Enter your new password',
    ENTER_YOUR_NEW_USERNAME: 'Enter your new username',
    ERROR: 'Erreur',
    ERROR_ADD_ACCOUNT: 'Error : Account cannot be added',
    ERROR_ADD_CATEGORY: 'Error : Categories cannot be added',
    ERROR_ADD_PERFORMANCE: 'Error : Performance cannot be added',
    ERROR_ADD_SITE: 'Error : Site cannot be added',
    ERROR_ADD_USER: 'Error : User cannot be added',
    ERROR_DATA_EXPORT: 'No data to export',
    ERROR_DELETE_PERFORMANCE: 'Error : Performance cannot be deleted',
    ERROR_DIFF_IMPORT: 'An error occured during import, please contact technical support on Slack.',
    ERROR_DUPLICATE_ACCOUNT: 'Error : Account cannot be duplicated',
    ERROR_FILE_TYPE_NOT_SUPPORTED: 'The file type is not supported.',
    ERROR_GET_TABLE: 'Error while getting proxies',
    ERROR_HEADER: 'Header error ',
    ERROR_IMPORT: 'There was a problem while importing, please reimport your file.',
    ERROR_IMPORT_ACCOUNT: 'Error : account cannot be imported.',
    ERROR_IMPORT_ACCOUNT_CHANGE: 'You have selected a new account, if you continue the previously made combinations of attribute with headers will be deleted.',
    ERROR_IMPORT_DUPLICATE_HEADER: 'Import not possible, the following headers are duplicated : ',
    ERROR_IMPORT_HEADER_CHANGE: 'The headers in the file have changed, if you continue the previously made combinations of attribute with headers will be deleted.',
    ERROR_MSG: 'The {name} attribut is not correctly set.',
    ERROR_MSG_PASSWORD: 'Passwords does not match or are empties.',
    ERROR_PROXY_HOST_ALREADY_USED: 'Error: Host already used',
    ERROR_RETAILER_SITE: 'Select a site link to the retailer account.',
    ERROR_UPDATE_ACCOUNT: 'Error : Account cannot be updated',
    ERROR_UPDATE_SITE: 'Error : Site cannot be updated',
    ERROR_UPDATE_USER: 'Error : User cannot be updated',
    EXCL: 'HT',
    EXPORT_DATA: 'Export data',
    FAILURE: 'Failure',
    FIELD_MATCH_RULES: 'Rules for the attributes with a match but not in key list',
    FILE_HEADER: 'File header',
    FILE_NAME: 'File name',
    FILTERS: 'Filters',
    FIRSTNAME: 'Firstname',
    FORCE_UPDATE: 'Force update',
    FROM: 'From',
    GENDER: 'Gender',
    GENERAL_INFORMATIONS: 'General informations',
    GENERATE_A_SCRIPT: 'Generate a script',
    GRANULARITY: 'Agregated by',
    GREATEST_DECREASES_IN_PERCENTAGE: 'Greatest decreases in percentage',
    GREATEST_DECREASES_IN_VALUE: 'Greatest decreases in value',
    GREATEST_INCREASES_IN_PERCENTAGE: 'Greatest increases in percentage',
    GREATEST_INCREASES_IN_VALUE: 'Greatest increases in value',
    HEADER: 'Header',
    HISTORY: 'History',
    HOME: 'Home',
    HOST: 'Host',
    HOURS: 'hours',
    ID: 'ID',
    IDENTIFIED_CATEGORIES: 'Identified Categories',
    IDENTIFIED_PRODUCTS: 'Identified Products',
    IMAP_CONFIGURATION: 'To activate an IMAP account, you must be connected to the ADBOX gmail account :',
    IMG_URL: 'Image url',
    IMPORT: 'Import',
    IMPORT_BRUT_DATA: 'Import brut data',
    IN_PROGRESS: 'In progress',
    IN_SECONDS: 'In seconds',
    INCL: 'TTC',
    INPUT_ARTICLE_RULE: 'Input article with no match in base',
    INPUT_FIELD_RULES: 'Rules for the attributes in case of article creation',
    INVALID_DATE: 'Invalid date',
    INVALID_ID_FORMAT: 'Invalid id',
    INVALID_PAGE_INDEX: 'Invalid page index',
    INVALID_PAGE_SIZE: 'Invalide page size',
    INVALID_PERIOD: 'Invalid period',
    INVALID_PROXY_COUNTRY: 'Invalid proxy country',
    INVALID_PROXY_TYPE: 'Invalid proxy type',
    INVALID_SORT: 'Invalid sort',
    INVALID_SPE_HIGHLIGHT_STATUS: 'Invalid SPE highlight status',
    INVALID_TOKEN: 'Invalid token',
    INVALID_URLS_ERROR: 'Please, enter valid Urls',
    INVALID_USER_ACTION: 'Invalid user action',
    IS_MARKET_PLACE: 'Marketplace ?',
    LANGUAGE: 'Language',
    LAST_UPDATE: 'Last update',
    LASTNAME: 'Lastname',
    LAT: 'Latitude',
    LAUNCH_ORDER_RECOVERY: 'Run the order recovery',
    LINK_TO_ATTRIBUTE: ' associate with the attribute ',
    LOGIN: 'Login',
    LOGIN_BUTTON: 'Login',
    LOGO_URL: 'Logo url',
    LOGOUT: 'Logout',
    LONG: 'Longitude',
    MANAGE_ACOUNTS_FOR_USER: 'Manage accounts for a user',
    MARKET_PLACE: 'Marketplace',
    MATCHING_HEADERS: 'Matching headers',
    MATCHING_SUMARY_ATTRIBUTE_OPTIONAL: 'Sumary of optional header attribute matchings',
    MATCHING_SUMARY_ATTRIBUTE_REQUIRED: 'Sumary of required header attribute matchings',
    MAX_CONNECTION: 'Max connection',
    MAX_PARALLEL_WORKERS: 'Max parallel workers',
    MODIFY: 'Modifier',
    MODIFY_NAME: 'Change username',
    MODIFY_PASSWORD: 'Change password',
    MODIFY_SITES_TO_SCRAP: 'Modify the sites to scrap',
    MODULES_CONFIGURATION: 'Modules configuration',
    MONTH: 'Months',
    MULTIPLE_ACCOUNTS: 'Multiple accounts',
    MULTIPLE_USERS: 'Multiple users',
    NAME: 'Name',
    NEW: 'NEW',
    NEW_ACCOUNT_NAME: 'New account\'s name',
    NEW_PASSWORD: 'New password',
    NEW_USERNAME: 'New username',
    NEXT: 'Next',
    NO: 'No',
    NO_FLOAT_ERROR: 'The delay has to be an integer !',
    NO_RECORDS_FOUND: 'No records found',
    NO_RIGHT: 'You do not have the right to do this',
    NONE: 'NONE',
    NOT_CONFIGURED_SITES: 'Not configured sites',
    OF: 'of',
    ONLY_CONFIGURED_SITES: 'Check to see only configured sites',
    OPEN_ALL: 'Ouvrir tout',
    OPTIONS: 'Options',
    ORDER_RETRIEVER: 'OrderRetriever',
    ORDER_SCRIPT_WARNING: '{scriptName} contains errors and cannot be launched',
    PAGE_NOT_FOUND: 'This page could not be found.',
    PAGE_SIZE: 'Page size',
    PARAMETERS: 'Parameters',
    PARAMS_A_DIFF: 'Params a smart differential',
    PASSWORD: 'Password',
    PERF_DIALOG_TITLE: 'Performance graph preview (colors will change in front app)',
    PERFORMANCES: 'Performances',
    PLEASE_ADD_FILE: 'Please add a file',
    PLEASE_SELECT_ACCOUNT: 'Please select account',
    PREVIOUS: 'Previous',
    PRICE: 'Price',
    PROCESSING_TIME: 'Processing time',
    PROVIDER: 'Fournisseur',
    PROXIES: 'Proxies',
    PROXY_COUNTRY: 'Proxy country',
    PROXY_MISSING_COUNTRY: 'Country field required',
    PROXY_MISSING_TYPE: 'Type field required',
    PROXY_SELECTOR_SUBTITLE: 'This window enables you to provide the proxy to use to recover the command number on {siteName}. If you do not fill this textField, a random and working proxy will be chosen.',
    PROXY_TYPE: 'Proxy type',
    PURCHASING_PRICE: 'Purchasing price',
    QUANTITY: 'Quantity',
    REF1: 'Reference 1',
    REF2: 'Reference 2',
    REF3: 'Reference 3',
    REMOVE_URLS: 'Remove all URLs',
    RESEARCH: 'Research',
    RESET: 'Reset',
    RIGHTS: 'Rights',
    ROBOT_VERSION: 'Robot version',
    ROWS_PER_PAGE: 'Rows per page',
    RRP: 'RRP',
    RRP_ALERT_PERCENTAGE: 'RRP alert percentage',
    SAVE: 'Save',
    SCRAPED_DATA_EDITOR: 'Scraped data editor',
    SCRAPED_PRODUCTS: 'Scraped Products',
    SCRAPING_CONTROL_DURATION: 'Scraping control duration',
    SCRAPING_DATA_EDITOR: 'Scraping data editor',
    SCRAPING_GENERATOR: 'ScrapGenerator',
    SEE_ARTICLE: 'See the article',
    SEE_GRAPH: 'See chart',
    SEE_TABLE: 'See data table',
    SELECT_A_KEY: 'Select a key',
    SELECT_ACCOUNT: 'Select account',
    SELECT_FILE: 'Select file',
    SELECT_HEADER: 'Select an header',
    SEPARATOR: 'Separator',
    SET_ATTRIBUTES_RULES: 'Set attributes rules',
    SET_ITEMS_RULES: 'Set items rules',
    SETTINGS: 'Settings',
    SHIPPING_COUNTRY: 'Shipping country',
    SIGN_IN_ERROR: 'Wrong email or wrong password',
    SIGN_IN_SUCCESS: 'You are connected!',
    SITE: 'Site',
    SITE_CONFIG_ADBOX_TITLE: 'Email list of the expeditors associated to the stie',
    SITE_NAME: 'Site name',
    SITE_NOT_FOUND: 'Site not found.',
    SITES: 'Sites',
    SITES_MANAGER: 'Sites Manager',
    SIZE: 'Size',
    SKU: 'SKU',
    SORT: 'Sort',
    SPE_ARTICLE_RULE: 'Article in base with no match with article in input',
    SPE_FIELD_RULES: 'Rules for the attributes in base with no match in input',
    SPE_HIGHLIGHTED_ITEMS: 'Top price changes',
    STATUS: 'Status',
    STOCK: 'Stock',
    STOCK_5_DAYS: '+5 days',
    STOCK_IN: 'In stock',
    STOCK_NO_INFORMATION: 'Stock not specified',
    STOCK_SOLD_OUT: 'Sold out',
    STOCK_SUP_48H: 'Greater than 48h',
    SUCCESS: 'Success',
    SUCCESS_ADD_ACCOUNT: 'Account successfully added',
    SUCCESS_ADD_PERFORMANCE: 'Performance successfully added',
    SUCCESS_ADD_SITE: 'Site successfully added',
    SUCCESS_ADD_USER: 'User successfully added',
    SUCCESS_COPY: 'Copied to clipboard',
    SUCCESS_DELETE_PERFORMANCE: 'Performance successfully deleted',
    SUCCESS_DUPLICATE_ACCOUNT: 'Account successfully duplicated',
    SUCCESS_IMPORT_ACCOUNT: 'Account successfully imported',
    SUCCESS_UPDATE_ACCOUNT: 'Account successfully updated',
    SUCCESS_UPDATE_PERFORMANCE: 'Performance successfully updated',
    SUCCESS_UPDATE_SITE: 'Site successfully updated',
    SUCCESS_UPDATE_USER: 'User successfully updated',
    SUPER_USER: 'Super user',
    TAG: 'Tag',
    TAX_MODE: 'Tax mode',
    TAXES_EXCLUDED: 'Excl. VAT',
    TAXES_INCLUDED: 'Incl. VAT',
    TEST_KEY: 'Test key',
    TEST_THE_SCRIPT: 'Test the script',
    TO: 'To',
    TRUST_ALERT_THRESHOLD: 'Trust alert threshold',
    TYPE: 'Type',
    UNAUTHORIZED_PAGE: 'You are not authorized to access to this page.',
    UNLOCK_ALL_FIELDS: 'Unlock all fields',
    UPDATE_PERFORMANCE: 'Update performance',
    URL: 'Url',
    USER: 'User',
    USER_ACTIONS: 'User Actions',
    USER_BLOCKED: 'User blocked',
    USERNAME: 'Username',
    USERNAME_HAS_BEEN_CHANGED: 'You username has been changed',
    USERS: 'Users',
    USERS_LIST: 'List of users',
    USERS_MANAGER: 'User Manager',
    VISIBLES_SITES: 'Sites visibles',
    VISIBLES_STATUS: 'Status visibles',
    WAIT: 'Wait',
    WAITING_FOR_RESULTS: 'Waiting for results',
    WARNING: 'Warning',
    WARNING_ACTIVATE_1: 'If the account has access to the SPE and Pricing Engine modules, the scraping robots will (re)start to collect the prices AND the daily monitoring will be sent every morning.',
    WARNING_ACTIVATE_2: 'If the account has access to the Slider module, the slider bot will (re)start to scrap advertising banners.',
    WARNING_ACTIVATE_3: 'Are you sure you want to continue ?',
    WARNING_ACTIVATE_ACCOUNT: 'Please note, you are activating the account {name}',
    WARNING_DEACTIVATE_1: 'If the account has access to the SPE and Pricing Engine modules, the scraping robots will no longer scrap the products AND the daily monitoring emails will no longer be sent.',
    WARNING_DEACTIVATE_2: 'If the account has access to the Slider module, the slider bot will no longer scrap the advertising banners.',
    WARNING_DEACTIVATE_3: 'Are you sure you want to continue ?',
    WARNING_DEACTIVATE_ACCOUNT: 'Attention, you are deactivating the account {name}',
    WEEKS: 'Weeks',
    YES: 'Yes'
};
export default locales;
